/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//French (France)
export default {
  'fabric.emoji.add.custom.emoji.label': 'Ajouter votre propre émoticône',
  'fabric.emoji.add.label': 'Ajouter une émoticône',
  'fabric.emoji.cancel.label': 'Annuler',
  'fabric.emoji.categories.label': "Choisir une catégorie d'émoticônes",
  'fabric.emoji.categories.search.results': 'Résultats de recherche',
  'fabric.emoji.category.activity': 'Activité',
  'fabric.emoji.category.all.uploads': 'Tous les chargements',
  'fabric.emoji.category.flags': 'Drapeaux',
  'fabric.emoji.category.foods': 'Aliments et boissons',
  'fabric.emoji.category.frequent': 'Fréquents',
  'fabric.emoji.category.nature': 'Nature',
  'fabric.emoji.category.objects': 'Objets',
  'fabric.emoji.category.people': 'Personnes',
  'fabric.emoji.category.places': 'Voyage et lieux',
  'fabric.emoji.category.productivity': 'Atlassian et la productivité',
  'fabric.emoji.category.symbols': 'Symboles',
  'fabric.emoji.category.user.uploads': 'Vos chargements',
  'fabric.emoji.choose.file.screenReaderDescription':
    "Sélectionnez un fichier pour l'émoticône. Il doit être au format JPG, PNG ou GIF. Taille maximale : 1 Mo.",
  'fabric.emoji.choose.file.title': 'Sélectionner un fichier',
  'fabric.emoji.delete.description':
    'Toutes les instances existantes de cette émoticône seront remplacées par {emojiShortName}',
  'fabric.emoji.delete.label': 'Supprimer',
  'fabric.emoji.delete.screenreader.tooltip':
    "Pour supprimer l'émoticône {shortName}, appuyez sur la touche Retour arrière",
  'fabric.emoji.delete.title': "Supprimer l'émoticône",
  'fabric.emoji.delete.tooltip': 'Supprimer',
  'fabric.emoji.emojipicker.emoi.roledescription': "bouton d'émoticône",
  'fabric.emoji.emojipicker.error': 'Erreur !',
  'fabric.emoji.error.delete.failed': 'Échec de la suppression',
  'fabric.emoji.error.image.too.big': "L'image sélectionnée est supérieure à 1 Mo",
  'fabric.emoji.error.invalid.image': "L'image sélectionnée n'est pas valide",
  'fabric.emoji.error.upload.failed': 'Échec du chargement',
  'fabric.emoji.error.upload.timeout': "L'importation a expiré",
  'fabric.emoji.image.requirements': 'JPG, PNG ou GIF. Taille max. : 1 Mo.',
  'fabric.emoji.name.ariaLabel': 'Saisissez le nom du nouvel emoji',
  'fabric.emoji.picker': "Sélecteur d'émoticône",
  'fabric.emoji.pickerlist.grid': '{showSearchResults, select, true {Résultats de la recherche} other {Émoticônes}}',
  'fabric.emoji.pickerlist.tabpanel': "Volet d'actions d'émoticône et de listes",
  'fabric.emoji.placeholder': 'Par exemple : bonjour',
  'fabric.emoji.preview': 'Votre nouvelle émoticône {emoji} est super',
  'fabric.emoji.preview.title': 'Afficher un aperçu',
  'fabric.emoji.retry.label': 'Réessayer',
  'fabric.emoji.search.label': "Nom de l'émoticône",
  'fabric.emoji.search.placeholder': 'Rechercher',
  'fabric.emoji.search.status': 'Voir toutes les émoticônes',
  'fabric.emoji.search.status.count': '{count} émoticônes trouvées',
  'fabric.emoji.select.skin.list.ariaLabel': 'Sélecteur de phototype',
  'fabric.emoji.select.skin.tone.ariaLabel': 'Choisissez votre phototype ; phototype sélectionné : {selectedTone}',
};
